import React, { useCallback } from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { KeyValueSelect } from '../../shipment-configuration-widget/key-value-select';
import PropTypes from 'prop-types';
import { confirmationId } from '../constants';
import { emptyArray } from 'ui-components/default-props/empty';

const messages = defineMessages({
  label: {
    description: 'shipping preset confirmation option placeholder label',
    defaultMessage: 'Confirmation',
    id: 'iT2IIZ',
  },
});

export const ConfirmationPresetOption = ({ confirmations = emptyArray, data, onChange }) => {
  const onConfirmationChange = useCallback(
    (value) => {
      onChange({ name: confirmationId, value });
    },
    [onChange],
  );

  return (
    <KeyValueSelect
      items={confirmations}
      label={<FormattedMessage {...messages.label} />}
      onChange={onConfirmationChange}
      selectedItem={data}
    />
  );
};

ConfirmationPresetOption.propTypes = {
  confirmations: PropTypes.array,
  data: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};
